<div class="audience-summary-container">
  <!-- Header -->
  <div class="summary-header">
    <h3 class="summary-title">AI Audience summary</h3>
    <p class="summary-subtitle">Find the updates from your audience here</p>
  </div>

  <!-- Empty State -->
  <div *ngIf="!audience" class="empty-state">
    <div class="empty-state-icon">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
        <rect x="8" y="16" width="48" height="40" rx="2" stroke="#DCDCDC" stroke-width="2" fill="none"/>
        <path d="M8 24 L32 40 L56 24" stroke="#DCDCDC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="16" y1="32" x2="24" y2="36" stroke="#DCDCDC" stroke-width="2" stroke-linecap="round"/>
        <line x1="40" y1="36" x2="48" y2="32" stroke="#DCDCDC" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </div>
    <p class="empty-state-text">No audience created yet, create your audience by chatting to AI</p>
  </div>

  <!-- Content -->
  <div *ngIf="audience" class="summary-content">
    <!-- Estimated Reach -->
    <div *ngIf="audienceSize" class="summary-section">
      <h4 class="section-title">Estimated reach</h4>
      <div class="badge-container">
        <app-sp-audience-score
          [score]="audienceScore"
          [variant]="'badge'"
          [audienceSize]="audienceSize">
        </app-sp-audience-score>
      </div>
    </div>

    <!-- Demographics -->
    <div class="summary-section">
      <h4 class="section-title">Demographics</h4>
      <div class="badge-container">
        <span class="badge badge-info">Age: {{ audience.ageMin }} - {{ audience.ageMax }}</span>
        <span class="badge badge-info">Gender: {{ genderText }}</span>
      </div>
    </div>

    <!-- Location -->
    <div *ngIf="locations.length > 0" class="summary-section">
      <h4 class="section-title">Location</h4>
      <div class="badge-container badge-wrap">
        <span *ngFor="let location of locations" class="badge badge-info">{{ location }}</span>
      </div>
    </div>

    <!-- Locales -->
    <div *ngIf="localeLabels.length > 0" class="summary-section">
      <h4 class="section-title">Languages</h4>
      <div class="badge-container badge-wrap">
        <span *ngFor="let locale of localeLabels" class="badge badge-info">{{ locale }}</span>
      </div>
    </div>

    <!-- Relationship Statuses -->
    <div *ngIf="relationshipStatusLabels.length > 0" class="summary-section">
      <h4 class="section-title">Relationship Status</h4>
      <div class="badge-container badge-wrap">
        <span *ngFor="let status of relationshipStatusLabels" class="badge badge-info">{{ status }}</span>
      </div>
    </div>

    <!-- Flexible Spec Groups (AND logic) -->
    <div *ngIf="flexibleSpecGroups.length > 0" class="summary-section">
      <h4 class="section-title">Targeting Groups</h4>

      <ng-container *ngFor="let group of flexibleSpecGroups; let i = index">
        <!-- AND separator between groups -->
        <div *ngIf="i > 0" class="and-separator">
          <span class="operator-badge">AND</span>
        </div>

        <div class="targeting-group">
          <!-- Interests (OR logic within group) -->
          <div *ngIf="group.interests.length > 0" class="group-category">
            <div class="category-label">Interests:</div>
            <div class="badge-container badge-wrap">
              <ng-container *ngFor="let interest of group.interests; let isLast = last">
                <span class="badge badge-info">{{ interest }}</span>
                <span *ngIf="!isLast" class="or-label">OR</span>
              </ng-container>
            </div>
          </div>

          <!-- Occupation (OR logic within group) -->
          <div *ngIf="group.occupations.length > 0" class="group-category">
            <div class="category-label">Occupations:</div>
            <div class="badge-container badge-wrap">
              <ng-container *ngFor="let item of group.occupations; let isLast = last">
                <span class="badge badge-info">{{ item }}</span>
                <span *ngIf="!isLast" class="or-label">OR</span>
              </ng-container>
            </div>
          </div>

          <!-- Behavior (OR logic within group) -->
          <div *ngIf="group.behaviors.length > 0" class="group-category">
            <div class="category-label">Behaviors:</div>
            <div class="badge-container badge-wrap">
              <ng-container *ngFor="let item of group.behaviors; let isLast = last">
                <span class="badge badge-info">{{ item }}</span>
                <span *ngIf="!isLast" class="or-label">OR</span>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="summary-actions">
    <button class="btn-apply" [disabled]="!audience" (click)="handleApply()">Continue to editor</button>
    <p class="helper-text">You'll be able to refine and adjust this audience manually</p>
  </div>
</div>
